const allhierarchy = { data: [], loading: true };

export const GetAllHierarchyRed = (state = allhierarchy, action) => {
  switch (action.type) {
    case "get_allhierarchy":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
